import { tryAxios } from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'

const apiUrl = `${urlPrefix}/Roles`
//#region 角色相关
const GetRolesByUserType = `${apiUrl}/GetRolesByUserType`
const GetList = `${apiUrl}`
const Post = `${apiUrl}`
const Delete = (id: number) => `${apiUrl}/${id}`
const Get = (id: number) => `${apiUrl}/${id}`
const Put = (id: number) => `${apiUrl}/${id}`
const SearchUsers = `${apiUrl}/GetUsersForRole`
//#endregion

export interface RoleMenuData {
    [key: string]: any
    Seq: number
    MenuId: number
    MenuName: string
    DisplayName: string
    Icon: string
    ParentId: number
    ParentName: string
    Comments: string
    IsMenu: boolean
    // 页面按钮权限
    HasAdd: boolean
    HasApprove: boolean
    HasDecline: boolean
    HasDel: boolean
    HasEdit: boolean
    HasView: boolean
    // 按钮启用权限
    ShowAdd: boolean
    ShowApprove: boolean
    ShowDecline: boolean
    ShowDel: boolean
    ShowEdit: boolean
    Childs: RoleMenuData[]
}
export interface RoleUserData {
    [key: string]: any
    UserId: number
    UserType: number
    UserName: string
    DisplayName: string
    EMail: string
    CellPhone: string
}
export interface RoleAccessData {
    [key: string]: any
    Id: number
    RoleId: number
    ItemType: number//1安全隐患 2巡查内容 3项目分类 
    ItemId: number
    ItemName: string
}
export interface RoleData {
    [key: string]: any
    RoleId: number
    UserType: number
    RoleName: string
    Comments: string
    // 菜单及功能权限
    MenuList: RoleMenuData[]
    // 关联用户
    UserList: RoleUserData[]
    AccessList:RoleAccessData[]
}
// 根据用户类型导入角色
export const getRolesByUserType = (_userType: number) => {
    return tryAxios({
        method: 'get',
        url: GetRolesByUserType,
        params: { userType: _userType }
    })
}
// 角色管理中，根据用户类型查询相应用户
export const searchUsers = (_keyword: string, _userType: number, _roleId: number) => {
    return tryAxios({
        method: 'get',
        url: SearchUsers,
        params: {
            keyword: _keyword,
            userType: _userType,
            roleId: _roleId
        }
    })
}
export const getList = (param?: any) => {
    return tryAxios({
        method: 'get',
        url: GetList,
        params: param
    })
}
export const remove = (id: number) => {
    return tryAxios({
        method: 'delete',
        url: Delete(id)
    })
}
export const getData = (id: number) => {
    return tryAxios({
        method: 'get',
        url: Get(id)
    })
}
export const postData = (form: any) => {
    return tryAxios({
        method: 'post',
        url: Post,
        data: form
    })
}
export const putData = (id: number, form: any) => {
    return tryAxios({
        method: 'put',
        url: Put(id),
        data: form
    })
}
